export default __webpack_public_path__ + "static/media/free_pass.52d9e93a.png";